import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TeAiService} from "../../../service/api/te-ai.service";
import {TeAiTestDataResponseDto} from "../../../model/dto/api/te-ai-test-data-response.dto";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";

@Component({
    selector: 'te-ai-test-data-dialog',
    templateUrl: './te-ai-test-data-dialog.component.html',
    standalone: false
})
export class TeAiTestDataDialogComponent {

    @Input() templateId: number;
    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onApplied = new EventEmitter<void>();

    scenarios: TeAiTestDataResponseDto[] = [];
    loading: boolean = false;
    applying: boolean = false;

    constructor(
        private aiService: TeAiService,
        private messageService: MvsMessageService
    ) {}

    generate() {
        if (!this.templateId) return;

        this.loading = true;
        this.scenarios = [];
        this.aiService.generateTestData(this.templateId).subscribe({
            next: (result) => {
                this.scenarios = result;
                this.loading = false;
            },
            error: () => {
                this.messageService.showErrorMessage('AI', 'Fehler bei der Testdatengenerierung.');
                this.loading = false;
            }
        });
    }

    applyScenario(scenario: TeAiTestDataResponseDto) {
        this.applying = true;
        this.aiService.applyTestData({
            templateId: this.templateId,
            testCaseName: scenario.testCaseName,
            variables: scenario.variables
        }).subscribe({
            next: () => {
                this.messageService.showSuccessMessage('AI', `Testfall "${scenario.testCaseName}" wurde erstellt.`);
                this.applying = false;
                this.onApplied.emit();
            },
            error: () => {
                this.messageService.showErrorMessage('AI', 'Fehler beim Anwenden des Testfalls.');
                this.applying = false;
            }
        });
    }

    getScenarioIcon(scenario: string): string {
        switch (scenario) {
            case 'happy_path': return 'fa-regular fa-check-circle';
            case 'edge_case': return 'fa-regular fa-exclamation-triangle';
            case 'minimal': return 'fa-regular fa-minus-circle';
            default: return 'fa-regular fa-flask';
        }
    }

    getScenarioLabel(scenario: string): string {
        switch (scenario) {
            case 'happy_path': return 'Happy Path';
            case 'edge_case': return 'Edge Case';
            case 'minimal': return 'Minimal';
            default: return scenario;
        }
    }

    close() {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}
